function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.replace(/\/+$/, '');
}

function normalizeAssetPath(assetPath: string): string {
  return assetPath.replace(/^\/+/, '');
}

function getStaticAssetBaseUrl(): string | null {
  const value = process.env.STATIC_ASSET_BASE_URL?.trim();

  if (!value) {
    return null;
  }

  try {
    return normalizeBaseUrl(new URL(value).toString());
  } catch {
    return null;
  }
}

function getStaticAssetDeploymentVersion(): string | null {
  const value = process.env.STATIC_ASSET_DEPLOYMENT_VERSION?.trim();
  return value && value.length > 0 ? value : null;
}

export function usesVersionedStaticAssets(): boolean {
  return Boolean(getStaticAssetBaseUrl() && getStaticAssetDeploymentVersion());
}

export function getVersionedPublicAssetUrl(assetPath: string, fallbackOrigin?: string): string {
  const normalizedAssetPath = normalizeAssetPath(assetPath);
  const staticAssetBaseUrl = getStaticAssetBaseUrl();
  const staticAssetDeploymentVersion = getStaticAssetDeploymentVersion();

  if (staticAssetBaseUrl && staticAssetDeploymentVersion) {
    return `${staticAssetBaseUrl}/assets/${staticAssetDeploymentVersion}/${normalizedAssetPath}`;
  }

  const relativePath = `/${normalizedAssetPath}`;
  if (!fallbackOrigin) {
    return relativePath;
  }

  return `${normalizeBaseUrl(fallbackOrigin)}${relativePath}`;
}
